import React, { useState } from "react";
import { IoClose } from "react-icons/io5";
import { useTranslation } from "react-i18next";
import { downloadBlob, postMultipartWithAuthCall } from "../../api/ApiServices";
import ApiConfig from "../../api/ApiConfig";
import Params from "../../config/Params";
import { toast } from "react-toastify";

function TeacherImport() {
  const [showclose, setShowClose] = useState();
  const [showimage, setShowImage] = useState();
  const { t } = useTranslation();

  const [file, setFile] = useState(null)

  const downloadTeacherFormat = () => {

    downloadBlob(ApiConfig?.DOWNLOAD_TEACHER_FORMAT_EXCEL, JSON.stringify({
      api_key: Params.api_key,
      customer_id: Params.customer_id,
    }), "Teacher_Data_format")

  }

  const handleImport = () => {

    if (!file) {
      toast.error('Pleas Select File!')
      return
    }

    const formData = new FormData()

    formData.append('api_key', Params?.api_key)
    formData.append('customer_id', Params?.customer_id)
    formData?.append('template', file)

    postMultipartWithAuthCall(ApiConfig.IMPORT_TEACHERS, formData).then((res) => {

      if (res?.result) {
        toast.success(res?.message)
      } else {
        toast.error(res?.message)
      }

    })

  }

  return (
    <div className="row edsys-table">
      <div className="col-sm-12">
        <div className="d-flex">
          <h5 className="mb-2 flex-grow-1">{t("Import Teacher Data")}</h5>
        </div>
        <div className="card">
          <div className="card-header">
            <div className="row">
              <div className="col-lg-6">
                {showclose ? (
                  <div className="div_Succesfull">
                    <label>{t("Imported Successfully")}</label>
                    <IoClose onClick={() => setShowClose(!showclose)} />
                  </div>
                ) : null}

                <div className="form-group col-md-12">
                  <label for="task-title">{t("Upload File")}</label>
                  <input
                    className="datepicker-here form-control digits"
                    type="file"
                    onChange={(e) => setFile(e.target.files[0])}
                    accept=".xls, .xlsx"
                  />
                </div>
                <div className="teacherimportbutton">
                  <div className="">
                    <button
                      className="btn btn-primary"
                      type="button"
                      onClick={handleImport}
                    >
                      {t("Import")}
                    </button>
                  </div>
                  <div className="">
                    <button className="btn btn-primary" type="button"
                      onClick={downloadTeacherFormat}
                    >
                      {t("Download Import Format")}
                    </button>
                  </div>
                </div>
                <div style={{ marginTop: "10px" }}>
                  <label className="Instruction_label">
                    {t("Please follow the instruction before uploading the file")}.
                  </label>
                  <ul className="Instruction_list">
                    <li>{t("Uploading file should be a xls file")}.</li>
                    <li>
                      {t("Date format is Year-Month-Date for example 2014-12-20")}.
                    </li>
                    <li>
                      {t("Successive rows should be filled out from first row  onwords")} .

                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-lg-6">
                {showimage ? (
                  <div className="div_Succesfull">
                    <label>{t("Imported Successfully")}</label>
                    <IoClose onClick={() => setShowImage(!showimage)} />
                  </div>
                ) : null}

                <div className="form-group col-md-12">
                  <label for="task-title">{t("Upload File")}</label>
                  <input
                    className="datepicker-here form-control digits"
                    type="file"
                  />
                </div>
                <div className="schedulebutton">
                  <div className="">
                    <button
                      className="btn btn-primary"
                      type="button"
                      onClick={() => setShowImage(true)}
                    >
                      {t("Upload Images")}
                    </button>
                  </div>
                </div>
                <div style={{ marginTop: "10px" }}>
                  <label className="Instruction_label">
                    {t("This feature is used to upload images of imported Teachers  using excel sheet")}.

                  </label>
                  <ul className="Instruction_list">
                    <li>{t("Image name shoud be specified in excel")}</li>.
                    <li>
                      {t("Uploading file should be a zip file of single image or multiple images")}.

                    </li>
                    <li>
                      {t("zip file should not include any file other than image  extension")}.

                    </li>
                    <li>
                      {t("Create a new folder and copy images to that folder then compress that folder to zip format")}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TeacherImport;
